import { styled } from '@mui/material/styles';
import { CenterContent } from 'global/components/perform-grid';

export const PolicyContent = styled(CenterContent)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  marginBottom: theme.spacing(8),
  overflowWrap: 'anywhere',
  [theme.breakpoints.up('md')]: {
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: theme.breakpoints.values.md,
  },
}));

export const PolicyActive = styled('span')({
  fontWeight: 'bold',
});

export const PolicyPerformLogo = styled('img')({
  margin: '10px',
  maxWidth: '350px',
  maxHeight: '120px',
});

export const PolicyLogos = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  height: 100,
});

export const PolicyIcon = styled('div')({
  color: 'white',
  display: 'flex',
  alignItems: 'center',
});
